export default "https://cdn-static.gokick.com/assets/eeaee1442152ca0221916151b947444cbee5198d/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";